import { LoadingStates } from '@pb/utils'

import { OFFERS_TAB } from '../constants'

export default {
  rewards: [],
  wasRewardsResponseEmpty: false,
  rewardsLoadingState: LoadingStates.NotLoaded,
  rewardDetailLoadingState: LoadingStates.NotLoaded,
  redeemOfferLoadingState: LoadingStates.NotLoaded,
  addOfferToBagLoadingState: LoadingStates.NotLoaded,
  addOfferToBagErrorMessage: '',
  promotionCode: '',
  promotionCodeErrorMessage: '',
  promotionCodeLoadingState: LoadingStates.NotLoaded,
  offers: [],
  vouchers: [],
  selectedTab: OFFERS_TAB.id,
}
